







import { Component, Prop, Vue } from "vue-property-decorator";

import ChipStack from "@/components/game/chipStack/ChipStack.vue";

@Component({
    components: { ChipStack }
})
export default class Bet extends Vue {
    @Prop() chipCount!: bigint;
}
